import React, { useContext } from 'react';

let isProviderInit = false;
let config = {};

export const ConfigContext = React.createContext({
  hasNoProvider: true,
});

ConfigContext.displayName = 'ConfigContext';

export const ConfigContextProvider = ({ value, children }) => {
  let currentConfig = value;

  if (isProviderInit) {
    console.error('@ott/config-context: конфигурацию нельзя менять');
    currentConfig = config;
  } else {
    config = value;
  }

  isProviderInit = true;

  return <ConfigContext.Provider value={currentConfig}>{children}</ConfigContext.Provider>;
};

let wasWarnedAboutProvider = false;
const sanityCheck = (configState) => {
  const { hasNoProvider } = configState;
  if (hasNoProvider && !wasWarnedAboutProvider) {
    console.warn(
      `Missing ConfigContextProvider in rendered components hierarchy.
      To fix that, please add ConfigContextProvider as parent in component tree.
      For example in client.js:
      export default () => <ConfigContext.Provider><App /></ConfigContext.Provider>`
    );
    wasWarnedAboutProvider = true;
  }

  return configState;
};

export const withConfigContext = (Component) =>
  function ConfigContextWrapper(props) {
    return (
      <ConfigContext.Consumer>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        {(configState) => <Component {...props} config={sanityCheck(configState)} />}
      </ConfigContext.Consumer>
    );
  };

export const useConfigContext = () => sanityCheck(useContext(ConfigContext));

export const getConfig = () => config;
